import { render, staticRenderFns } from "./EpisodeList.vue?vue&type=template&id=32dcb681&scoped=true&"
import script from "./EpisodeList.vue?vue&type=script&lang=js&"
export * from "./EpisodeList.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeList.vue?vue&type=style&index=0&id=32dcb681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dcb681",
  null
  
)

export default component.exports